import { css } from "@emotion/react";
import { Theme } from "../../../../styles/theme";

export const modalBodyTextStyle = (theme: Theme) => css`
  max-width: 405px;
  font-family: ${theme.fontFamilies.Primary};
  font-weight: ${theme.fontWeights["work-sans-2"]};
  line-height: 130%;
  margin: auto auto 10px;
  text-align: center;
`;

export const revokeAndApprovalSubtitleStyle = (isToApprove: boolean) => css`
  font-weight: 550;
  margin-top: ${isToApprove ? "15px" : "0px"};
  margin-bottom: 10px;
`;

export const revokeAndApprovalTextStyle = (theme: Theme) => css`
  font-size: ${theme.fontSize["4"]};
  font-weight: ${theme.fontWeights["work-sans-0"]};
  color: ${theme.font.secondary.default};
  padding-bottom: 15px;
  line-height: 20px;
`;
